import Footer from "./Footer";
import Header from "./Header";
import { images } from "../../common/Images";
import "../../styles/Favourites.css";
import { ApiCall, Web_url,Colors} from "../../common/Const";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Pagination} from "@mui/material";
import Search from "antd/es/transfer/search";



function Notifications() {
    const user = useSelector((state) => state.auth.user);
    const [notifylists, setNotifylists] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [type, setType] = useState('');
    const [search, setSearch] = useState('');
    const [clearSearchVal, setclearSearchVal] = useState(0);
    const [currentpage, setCurrentpage] = useState(0);
    const navigate = useNavigate();
    const srchRef = useRef();

    useEffect(() => {
        notifylist();
    }, [type,clearSearchVal]);
    const notifylist = (page = 0) => {
        ApiCall("getNotification", {
            customer_id: user && user.id > 0 && user.id,
            filter_type: type,
            search: search,
            page: page,
        })
            .then((data) => {
                if (data.message === "Notifications listed successfully.") {
                    setNotifylists(data.data);
                    setTotalCount(data.total_count);
                }
                else {
                    setNotifylists([]);
                }
            })
            .catch((err) => console.log(err));
    };
    const handleClick = (data) => {
        navigate("/offer-details", { state: { offer_detail: data } });
    };
    const handleChangePage = (page) => {
        setCurrentpage(page);
        notifylist((page - 1) * 30);
    };
    const setFilterVal = (value) => {
        setType(value);
    };
    const setSearchVal = (value) => {
        setSearch(value);
    };
    const clearSearch = () => {
        srchRef.current.value = "";
        setSearch('');
        setclearSearchVal(clearSearchVal+1);
      };
      const callSearchFilter = () => {
        notifylist();
      };
    return (
        <>
            <Header make={true} />
            <div className="offer-section">
                <p className="offer-head">Offers & Announcement</p>
                <div className="container pb-5">
                    <div>
                        <form>
                            <div className="mb-5">
                                <div className="input-group">
                                    <div className="input-group-prepend d-flex justify-content-center align-items-center" style={{ backgroundColor: '#126a38', borderRadius: '9px 0px 0 9px' }}>
                                        <span className="input-group-text" style={{ backgroundColor: '#126a38', border: 'none', outline: 'none', paddingRight: '5px' }} height="auto" id="basic-addon1">
                                            <img
                                                src={images.Hsearch}
                                                width="20"
                                                height="20"
                                                alt="user"
                                                className="rounded-circle"
                                            />
                                        </span>
                                    </div>
                                    <input type="text" style={{ backgroundColor: '#126a38' }} className="form-control border-0 search-input shadow-none" placeholder={"Search"} name="search" onChange={(e) => setSearchVal(e.target.value)}  ref={srchRef}/>
                                    <span role={"button"} style={{ backgroundColor: '#126a38', color: Colors.Base_color }} className="d-flex align-items-center px-2"  onClick={clearSearch}><i className="fa-regular fa-circle-xmark"></i></span>
                                    <span role={"button"} style={{ backgroundColor: Colors.Base_color, color: Colors.white_color }} className="d-flex align-items-center rounded-end px-2" onClick={callSearchFilter}>Search</span>
                                </div>
                            </div>

                            <div className="btn-group my-3">
                                <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Sort
                                </button>
                                <ul className="dropdown-menu">
                                    <li><span className="dropdown-item drop-head">Sort By</span></li>
                                    <hr style={{ margin: "0.2em" }}></hr>
                                    <li><label className="dropdown-item">
                                        <input
                                            type="radio"
                                            name="filter"
                                            onChange={(e) => setFilterVal('price_low')}
                                        />
                                        &nbsp;price: Low to High
                                    </label></li>
                                    <li><label className="dropdown-item">
                                        <input
                                            type="radio"
                                            name="filter"
                                            onChange={(e) => setFilterVal('price_high')}
                                        />
                                        &nbsp;price:High to Low
                                    </label></li>
                                    <li><label className="dropdown-item">
                                        <input
                                            type="radio"
                                            name="filter"
                                            onChange={(e) => setFilterVal('discount_low')}
                                        />
                                        &nbsp;Discount: Low to High
                                    </label></li>
                                    <li><label className="dropdown-item">
                                        <input
                                            type="radio"
                                            name="filter"
                                            onChange={(e) => setFilterVal('discount_high')}
                                        />
                                        &nbsp;Discount:High to Low
                                    </label></li>
                                    <li><a href="/notifications" className="dropdown-item">
                                        Reset
                                    </a></li>
                                </ul>
                            </div>
                        </form>
                    </div>
                    <div className="row">
                        {notifylists.length > 0 ? (
                            notifylists.map((notifylist, index) => {
                                return (
                                    <div key={notifylist.id} className="col-lg-3 col-md-4 mb-5" onClick={() => handleClick(notifylist)} style={{ cursor: "pointer" }}>
                                        <div className="card offer-box mx-2">
                                        {/* <img
                                                role={"button"}
                                                src={Web_url.Domain_url + notifylist.image}
                                                alt="offer"
                                                height="140px"
                                                className="offer-card-img"
                                            /> */}
                                            <picture><img
                                                role={"button"}
                                                src={Web_url.Domain_url + notifylist.image}
                                                alt="offer"
                                                height="140px"
                                                className="offer-card-img"
                                            /> </picture>
                                            <div className="card-body">

                                                <h5 className="offer-dis">{(notifylist.type === 1) ? "Min " + notifylist.discount + "% OFF" : null}</h5>
                                                <p className={notifylist.type === 2 ? "offer-title mb-0 pt-4" : "offer-title  mb-0"}>{notifylist.title}</p>
                                            </div>
                                        </div>
                                    </div>
                                );

                            })

                        ) : (
                            <div className="text-center">No offers Found.</div>
                        )}
                        <Pagination siblingCount={1} boundaryCount={0} count={(totalCount / 30).toString().split(".")[1] == undefined ? parseInt((totalCount / 30).toString().split(".")[0]) : parseInt((totalCount / 30).toString().split(".")[0]) + 1} variant="outlined" style={{ display: notifylists ? notifylists.length != 0 ? "block" : "none" : "none" }} shape="rounded" defaultPage={1} onChange={(e, page) => { handleChangePage(page) }} />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Notifications;